import React from 'react';

interface ProviderInfoBannerProps {
  username?: string;
  brandNames: string[];
}

/**
 * Provider information banner component
 */
export const ProviderInfoBanner: React.FC<ProviderInfoBannerProps> = ({
  username,
  brandNames
}) => {
  return (
    <div className="bg-brand-50 border border-brand-200 rounded-lg p-4">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
          <span className="text-brand-600 font-semibold text-sm">👤</span>
        </div>
        <div>
          <h3 className="text-sm font-medium text-brand-900">
            مزود الخدمة: {username || ''}
          </h3>
          <p className="text-xs text-brand-700">
            البراندات المرتبطة: {brandNames.length > 0 ? brandNames.join(', ') : 'لا توجد براندات مرتبطة'}
          </p>
        </div>
      </div>
    </div>
  );
};
